// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.content_CloV6 {
    height: 100%;
    width: 100%;
}

.content_CloV6 * {
    -webkit-box-sizing: border-box;
            box-sizing: border-box;
    border-collapse: collapse;
}

.contentArea_W4lpc {
    overflow-y: hidden;
}

.headerCell_cwoRe {
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
}

.resizer_co_Um {
    width: 10px;
    height: 100%;
    position: absolute;
    right: -5px;
    top: 0;
    z-index: 1;
}

.tableWrapper_NOn7g {
    overflow: hidden;
}

.table_TcOLB {
    overflow: auto;
    z-index: 1;
}

.table_TcOLB [data-sticky-td] {
    position: sticky;
}

.header_Z1z2n, .footer_iHfSX {
    position: sticky;
    width: -webkit-fit-content;
    width: -moz-fit-content;
    width: fit-content;
    z-index: 1;
    min-width: 100%;
}

.header_Z1z2n {
    top: 0;
}

.tbody_Z5gQr {
    z-index: 0;
    position: relative;
    min-width: 100%;
    width: -webkit-fit-content;
    width: -moz-fit-content;
    width: fit-content;
}

.footer_iHfSX {
    bottom: 0;
    left: 0;
}

.cell_n990r {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
}

.tableFilter_VEnkJ {
    padding: var( --size-padLarge );
    min-width : 300px;
}

.valueFilter_IGui5 {
    width: 100%;
}

.filterActive_YLvXF {
    color: var( --color-brand500 );
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/ui-elements/lib/esm/TableV2.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,8BAAsB;YAAtB,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;IACtB,qBAAqB;IACrB,iBAAiB;IACjB,oBAAa;IAAb,oBAAa;IAAb,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,MAAM;IACN,UAAU;AACd;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,UAAU;AACd;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,0BAAkB;IAAlB,uBAAkB;IAAlB,kBAAkB;IAClB,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,MAAM;AACV;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB,eAAe;IACf,0BAAkB;IAAlB,uBAAkB;IAAlB,kBAAkB;AACtB;;AAEA;IACI,SAAS;IACT,OAAO;AACX;;AAEA;IACI,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;AACvB;;AAEA;IACI,+BAA+B;IAC/B,iBAAiB;AACrB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,8BAA8B;AAClC","sourcesContent":[".content {\n    height: 100%;\n    width: 100%;\n}\n\n.content * {\n    box-sizing: border-box;\n    border-collapse: collapse;\n}\n\n.contentArea {\n    overflow-y: hidden;\n}\n\n.headerCell {\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n    display: flex;\n}\n\n.resizer {\n    width: 10px;\n    height: 100%;\n    position: absolute;\n    right: -5px;\n    top: 0;\n    z-index: 1;\n}\n\n.tableWrapper {\n    overflow: hidden;\n}\n\n.table {\n    overflow: auto;\n    z-index: 1;\n}\n\n.table :global([data-sticky-td]) {\n    position: sticky;\n}\n\n.header, .footer {\n    position: sticky;\n    width: fit-content;\n    z-index: 1;\n    min-width: 100%;\n}\n\n.header {\n    top: 0;\n}\n\n.tbody {\n    z-index: 0;\n    position: relative;\n    min-width: 100%;\n    width: fit-content;\n}\n\n.footer {\n    bottom: 0;\n    left: 0;\n}\n\n.cell {\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    overflow: hidden;\n    display: flex;\n    align-items: center;\n}\n\n.tableFilter {\n    padding: var( --size-padLarge );\n    min-width : 300px;\n}\n\n.valueFilter {\n    width: 100%;\n}\n\n.filterActive {\n    color: var( --color-brand500 );\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `content_CloV6`,
	"contentArea": `contentArea_W4lpc`,
	"headerCell": `headerCell_cwoRe`,
	"resizer": `resizer_co_Um`,
	"tableWrapper": `tableWrapper_NOn7g`,
	"table": `table_TcOLB`,
	"header": `header_Z1z2n`,
	"footer": `footer_iHfSX`,
	"tbody": `tbody_Z5gQr`,
	"cell": `cell_n990r`,
	"tableFilter": `tableFilter_VEnkJ`,
	"valueFilter": `valueFilter_IGui5`,
	"filterActive": `filterActive_YLvXF`
};
export default ___CSS_LOADER_EXPORT___;
